/**
 * Small per-item badge — quieter than `DemoModeBanner`, used inline (e.g. on each §9.3
 * health-grid node that isn't backed by a real `/healthz`/`/readyz` call, or on a tenant
 * field the real backend has no column for at all — plan/quota, checklist, storage usage)
 * so an operator scanning a screen can tell at a glance which values are real and which
 * aren't, without every field needing a paragraph of explanation. Reused verbatim (same
 * component, same visual language) for BOTH meanings — "simulated demo data" and "no
 * backend data source exists for this at all" — rather than inventing a second badge
 * pattern; `label`/`title` let a caller word the distinction accurately per the task brief's
 * "not available" framing without a new component.
 */
export function MockBadge({
  live = false,
  label,
  title,
}: {
  live?: boolean;
  /** Override the badge's text, e.g. "not available" instead of the default "mock". */
  label?: string;
  /** Override the badge's tooltip text. */
  title?: string;
}) {
  if (live) {
    return (
      <span className="mock-badge mock-badge--live" title={title ?? "Real, live call — not simulated."}>
        {label ?? "live"}
      </span>
    );
  }
  return (
    <span className="mock-badge" title={title ?? "This signal is simulated — no live data source exists for it yet."}>
      {label ?? "mock"}
    </span>
  );
}
